
import React, { createContext, useContext, ReactNode } from "react";
import { useAuthService } from "./authService";
import { useAuthSession } from "./useAuthSession";
import { AuthContextType } from "./types";

// Créer le contexte
export const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Créer un provider
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuthSession();
  const { signIn, signUp, signOut, resetPassword } = useAuthService();
  
  const value: AuthContextType = {
    user,
    loading,
    signIn,
    signUp,
    signOut,
    resetPassword
  };
  
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Hook pour utiliser le contexte
export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
};
